module.exports = __webpack_public_path__ + "static/img/mobilegreen1.b7be24d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/front/mobilegreen1.png
// module id = iVmk
// module chunks = 1